import * as CryptoJS from "crypto-js";
import * as Cliente from "./cliente.modelo";
import Swal from "sweetalert2";
import { environment } from "@environments/environment";
import { cAtmConnectConnection } from "./plataforma.modelo";

// ---------------- ENCRIPTACIÓN ----------------------

// Clave de cifrado genérica
const sKeyPrivate = "@@MagGiooooli$$2020";

// Cifra una cadena en AES
export function CifrarCadena(sCadena: string) {
  const skey: string = CryptoJS.AES.encrypt(sCadena, sKeyPrivate).toString();
  return skey;
}

// Descifra una cadena en AES
export function DescifrarCadena(sCadena: string) {
  const skey: string = CryptoJS.AES.decrypt(sCadena, sKeyPrivate).toString(
    CryptoJS.enc.Utf8,
  );
  return skey;
}

// ----------------- SESSION STORE ----------------

// Enumerado de variables SesionStore
// <any>'...' lo convierte a string, de lo contrario, lo pone numérico
// asignamos otro nombre a las variables para que no sea legible
export enum eSessionStore {
  IdCliente = "IC1050" as any,
  Nombre = "NC1060" as any,
  id_cliente = "ic1000" as any, // Id. del cliente
  osolicitante = "s1010" as any, // Objeto solicitante ISolicitante
  citatemporal = "ct1020" as any, // Indica si es cita temporal, acceso desde info. departamentos o trámites
  ocliente = "c1030" as any, // Objeto cliente cCliente
  nombrecliente = "nc1040" as any, // Nombre del cliente
  tokenurl_sol = "tku5000" as any,
  token_sol = "tk5010" as any,
  get_nif = "tk5020" as any,
  get_apellido1 = "tk5030" as any,
  get_apellido2 = "tk5040" as any,
  get_nombre = "tk5050" as any,
  get_email = "tk5060" as any,
  get_movil = "tk5070" as any,
  get_asunto = "tk5080" as any,
  get_id_area = "tk5090" as any,
  get_id_tramite = "tk5100" as any,
}

// Lee una variable del LocalStore cifrada
export function getSessionStore(eVariable: eSessionStore) {
  let sValor: string;
  sValor = sessionStorage.getItem(eVariable.toString());
  if (isNullUndefinedVacio(sValor)) {
    return "";
  } else {
    return DescifrarCadena(sValor);
  }
  // Los valores que no sean string para que no los trate siempre
  // como string hay que pasearlos con JSON.parse()
  // Ejemplo:
  // let role: myGlobals.eRole;
  // role = JSON.parse(myGlobals.getLocalStore(eLocalStore.roluser));
  return sValor;
}

// Almacena una variable en LocalStore cifrada
export function setSessionStore(eVariable: eSessionStore, sValor: string) {
  sessionStorage.setItem(eVariable.toString(), CifrarCadena(sValor));
}

// Borramos una variable del LocalStore
export function eliminarSessionStore(eVariable: eSessionStore) {
  sessionStorage.removeItem(eVariable.toString());
}

// Limpiamos todas las variables del LocalStore
export function clearSessionStore() {
  sessionStorage.clear();
}

// ----------------- LOCAL STORE ----------------

// Enumerado de variables LocalStore
// <any>'...' lo convierte a string, de lo contrario, lo pone numérico
export enum eLocalStore {
  tokenurl_sol = "tku5000" as any,
  token_sol = "tk5010" as any,
  ATM_CONNECT = "pa6000" as any,
  PublicUrl = "pu6010" as any,
  AtmConnectConnection = "pcc6020" as any,
}

// Lee una variable del LocalStore cifrada
export function getLocalStore(eVariable: eLocalStore) {
  let sValor: string;
  sValor = localStorage.getItem(eVariable.toString());
  if (isNullUndefinedVacio(sValor)) {
    return "";
  } else {
    return DescifrarCadena(sValor);
  }
  // Los valores que no sean string para que no los trate siempre
  // como string hay que pasearlos con JSON.parse()
  // Ejemplo:
  // let role: myGlobals.eRole;
  // role = JSON.parse(myGlobals.getLocalStore(eLocalStore.roluser));
  return sValor;
}

// Almacena una variable en LocalStore cifrada
export function setLocalStore(eVariable: eLocalStore, sValor: string) {
  localStorage.setItem(eVariable.toString(), CifrarCadena(sValor));
}

// Borramos una variable del LocalStore
export function eliminarLocalStore(eVariable: eLocalStore) {
  localStorage.removeItem(eVariable.toString());
}

// Limpiamos todas las variables del LocalStore
export function clearLocalStore() {
  localStorage.clear();
}

// --------------------- CONSTANTES Y ARRAYS --------------------

export const aDiaSemana: string[] = [
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
  "Domingo",
];
export const aMes: string[] = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

// --------------------- FUNCIONES DE fecha ----------------------------------

// Convierte una fecha del tipo AAAAMMDD a formato Date
export function fechaAAAAMMDDtoDate(sFecha: string): Date {
  if (!isNullUndefinedVacio(sFecha) && sFecha.length === 8) {
    return new Date(
      parseInt(sFecha.substring(0, 4)),
      parseInt(sFecha.substring(4, 6)) - 1,
      parseInt(sFecha.substring(6, 8)),
    );
  } else {
    return null;
  }
}

// Convierte una fecha del tipo Date a formato AAAA-MM-DD, por defecto devuelve
// la fecha el día
export function fechaDatetoAAAA_MM_DD(f: Date): string {
  // Sino se recibe ninguna fecha se coge por defecto la del día
  if (isNullUndefined(f)) {
    f = new Date();
  }
  return (
    f.getFullYear().toString() +
    "-" +
    (f.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    f.getDate().toString().padStart(2, "0")
  );
}

// Convierte una fecha del tipo AAAAMMDD a formato DD-MM-AAAA
export function fechaAAAAMMDDtoDD_MM_AAAA(sFecha: string): string {
  if (!isNullUndefinedVacio(sFecha) && sFecha.length === 8) {
    return (
      sFecha.substring(6, 8) +
      "-" +
      sFecha.substring(4, 6) +
      "-" +
      sFecha.substring(0, 4)
    );
  } else {
    return null;
  }
}

// Convierte una fecha del tipo AAAAMMDD a formato AAAA-MM-DD
export function fechaAAAAMMDDtoAAAA_MM_DD(sFecha: string): string {
  if (!isNullUndefinedVacio(sFecha) && sFecha.length === 8) {
    return (
      sFecha.substring(0, 4) +
      "-" +
      sFecha.substring(4, 6) +
      "-" +
      sFecha.substring(6, 8)
    );
  } else {
    return null;
  }
}

// Convierte una fecha del tipo AAAA-MM-DD a formato AAAAMMDD numérico
export function fechaAAAA_MM_DDtoAAAAMMDD(sFecha: string): number {
  if (!isNullUndefinedVacio(sFecha) && sFecha.length === 10) {
    return parseInt(
      sFecha.substring(0, 4) + sFecha.substring(5, 7) + sFecha.substring(8, 10),
    );
  } else {
    return null;
  }
}

// Convierte una fecha del tipo Date a formato AAAAMMDD
export function fechaDatetoAAAAMMDD(f: Date): number {
  return parseInt(
    f.getFullYear().toString() +
      (f.getMonth() + 1).toString().padStart(2, "0") +
      f.getDate().toString().padStart(2, "0"),
  );
}

// Devuelve los días totales que tiene un mes
export function fechaDiasTotalesMes(iAnnio: number, iMes: number): number {
  return new Date(iAnnio, iMes, 0).getDate();
}

// Convierte una fecha de texto, dado la opción de incluir el día de la semana
export function fechaDateATexto(f: Date, incluirDiaSemana: boolean): string {
  let sFechaTexto = "";

  if (incluirDiaSemana) {
    sFechaTexto = fechaDiaSemanaString(f) + ", ";
  }
  sFechaTexto =
    sFechaTexto +
    f.getDate().toString() +
    " de " +
    aMes[f.getMonth()] +
    " del " +
    f.getFullYear().toString();

  return sFechaTexto;
}

// Día de la semana de una fecha
export function fechaDiaSemanaString(f: Date): string {
  let iDiaSemana: number = f.getDay();
  let sDiaSemana = "";

  // el domingo se considera 0

  if (iDiaSemana === 0) {
    iDiaSemana = 7;
  }
  sDiaSemana = aDiaSemana[iDiaSemana - 1];

  return sDiaSemana;
}

// Día de la semana de una fecha 1 - lunes, 7 - domingo
export function fechaDiaSemana17(f: Date): number {
  let iDiaSemana: number = f.getDay();

  // el domingo se considera 0

  if (iDiaSemana === 0) {
    iDiaSemana = 7;
  }
  return iDiaSemana;
}

// Día de la semana de una fecha 0 - lunes, 6 - domingo
export function fechaDiaSemana06(f: Date): number {
  let iDiaSemana: number = f.getDay();

  // el domingo se considera 0

  if (iDiaSemana === 0) {
    iDiaSemana = 6;
  } else {
    iDiaSemana--;
  }
  return iDiaSemana;
}

// Suma o resta días a una fecha
export function fechaSumaRestaDias(f: Date, dias: number): Date {
  const faux: Date = new Date(f);
  const tiempo: number = faux.getTime();
  const milisegundos: number = dias * 24 * 60 * 60 * 1000; // milisegundos
  faux.setTime(tiempo + milisegundos);
  return faux;
}

// Calcula el nº total de meses entre 2 fechas
export function fechaTotalMeses(d1: Date, d2: Date): number {
  let meses = 0;
  meses = (d2.getFullYear() - d1.getFullYear()) * 12;
  meses -= d1.getMonth();
  meses += d2.getMonth() + 1;
  return meses <= 0 ? 1 : meses;
}

// Valida que el año de una fecha inicial y final no sea inferior o superior de un rango especificado
export function fechaAnnioTopeMinMax(
  anniomin: number,
  maximoannios: number,
  fini: Date,
  ffin: Date,
  mostraraviso: boolean,
): string {
  let sAviso = "";
  if (fini.getFullYear() < anniomin) {
    sAviso =
      "El año de la fecha inicial no puede ser menor del " +
      anniomin.toString() +
      ".";
  } else {
    if (ffin.getFullYear() > fini.getFullYear() + maximoannios) {
      sAviso =
        "El año de la fecha final no puede ser mayor del " +
        (fini.getFullYear() + maximoannios).toString();
    }
  }
  if (mostraraviso && !isNullUndefinedVacio(sAviso)) {
    Mensaje(eTipoMensaje.Advertencia, "", sAviso, "");
  }
  return sAviso;
}

// --------------------- FUNCIONES VARIAS ------------------------

// Comprueba si el objeto recibido es null o undefined
export function isNullUndefined(a: any): boolean {
  return a == null || a == undefined;
}

// Comprueba si la cadena recibida es null, undefined o vacia
export function isNullUndefinedVacio(a: string): boolean {
  return a == null || a == undefined || a === "";
}

// --------------------- MENSAJES --------------------------------

export enum eTipoMensaje {
  Advertencia = 0,
  Error = 1,
  Informacion = 2,
  OperacionOk = 3,
  OperacionNoOk = 4,
  BarraProgreso = 5,
  Close = 6,
}
export function Mensaje(
  eTipo: eTipoMensaje,
  sTitulo: string,
  sMensaje: string,
  sTextoBotonAceptar: string,
): void {
  Swal.close();

  if (eTipo !== eTipoMensaje.Close) {
    if (isNullUndefined(sTextoBotonAceptar) || sTextoBotonAceptar === "") {
      sTextoBotonAceptar = "Aceptar";
    }
    switch (eTipo) {
      case eTipoMensaje.Advertencia:
        Swal.fire({
          title: sTitulo,
          text: sMensaje,
          icon: "warning",
          confirmButtonText: sTextoBotonAceptar,
        });
        break;

      case eTipoMensaje.Error:
        Swal.fire({
          title: sTitulo,
          text: sMensaje,
          icon: "error",
          confirmButtonText: sTextoBotonAceptar,
        });
        break;

      case eTipoMensaje.Informacion:
        Swal.fire({
          title: sTitulo,
          text: sMensaje,
          icon: "info",
          confirmButtonText: sTextoBotonAceptar,
        });
        break;

      case eTipoMensaje.OperacionOk:
        Swal.fire({
          title: sTitulo,
          text: sMensaje,
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });
        break;

      case eTipoMensaje.OperacionNoOk:
        Swal.fire({
          title: sTitulo,
          text: sMensaje,
          icon: "warning",
          showConfirmButton: false,
          timer: 2000,
        });
        break;

      case eTipoMensaje.BarraProgreso:
        Swal.fire({
          allowOutsideClick: true,
          title: sTitulo,
          text: sMensaje,
        });
        Swal.showLoading();
        break;
    }
  }
}

// ----------------- VALIDACIONES ------------------

// Valida si un email es correcto
export function validarEmail(valor): boolean {
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (emailRegex.test(valor)) {
    return true;
  } else {
    return false;
  }
}
// ---------------- MENSAJES HTTP ------------------

export interface IRespuestaHTTP {
  STATUS: number;
  MENSAJE: string;
  OK: boolean;
  URL: string;
}

// Captura y opcionalmente muestra el mensaje HTTP.
// Devuelve un objeto IRespuestaHTTP
export function CapturaMensajeHTTP(
  errorHTTP: any,
  mostrarError: boolean,
): IRespuestaHTTP {
  let resp: IRespuestaHTTP = { STATUS: -1, MENSAJE: "", OK: false, URL: "" };
  let eTipoMsg: eTipoMensaje = eTipoMensaje.Advertencia;
  let sTitulo = "";
  let sMsgError = "";
  if (!isNullUndefined(errorHTTP)) {
    if (
      !isNullUndefined(errorHTTP.error) &&
      !isNullUndefinedVacio(errorHTTP.error.detail)
    ) {
      sMsgError = errorHTTP.error.detail as string;
    } else {
      sMsgError = errorHTTP.statusText as string;
    }

    resp = {
      STATUS: parseInt(errorHTTP.status),
      MENSAJE: sMsgError,
      OK: errorHTTP.ok as boolean,
      URL: errorHTTP.url as string,
    };

    // Los códigos de estado de respuesta HTTP indican si se ha completado
    // satisfactoriamente una solicitud HTTP específica.
    // Las respuestas se agrupan en cinco clases:

    // 1. Respuestas informativas (100–199),
    // 2. Respuestas satisfactorias (200–299),
    // 3. Redirecciones (300–399),
    // 4. Errores de los clientes (400–499),
    // 5. y errores de los servidores (500–599).

    if (resp.STATUS >= 100 && resp.STATUS <= 299) {
      eTipoMsg = eTipoMensaje.Informacion;
      sTitulo = "Información";
    } else if (resp.STATUS >= 400 && resp.STATUS <= 499) {
      eTipoMsg = eTipoMensaje.Error;
      sTitulo = "No hemos podido completar la solicitud";
    } else if (resp.STATUS >= 500 && resp.STATUS <= 599) {
      eTipoMsg = eTipoMensaje.Error;
      sTitulo = "El servicio no está disponible ahora mismo";
    }

    if (mostrarError) {
      Mensaje(eTipoMsg, sTitulo, resp.MENSAJE, "");
    }
  }
  return resp;
}

// ------------------ INFORMACIÓN DEL cliente -------------------------

// Atributo Alt de la imagen del logo del cliente
export function getImagenAlt(): string {
  const oCliente: Cliente.cCliente = oClienteActivo();
  if (isNullUndefined(oCliente)) {
    return "Atm Maggioli, S.L.";
  } else {
    return oCliente.client.nombre;
  }
}

// Dirección url del logo del cliente
export function getImagenLogo(): string {
  const oCliente: Cliente.cCliente = oClienteActivo();
  if (isNullUndefined(oCliente)) {
    return environment.additional.LOGO_ATM_MAGGIOLI;
  } else {
    return environment.backends.URL_API_ROOT + oCliente.client.imagen;
  }
}

// Comprueba si hay seleccionado un cliente o es 0 que significa que ha
// accedido un superusuario pero todavía no ha seleccinado ningún
export function HayClienteActivo(): boolean {
  let idcliente: string = getSessionStore(eSessionStore.id_cliente);

  if (isNullUndefinedVacio(idcliente)) {
    idcliente = "0";
  }
  return parseInt(idcliente) > 0;
}

// Retorna el id. del cliente activo, sino lo hay 0
export function IdClienteActivo(): number {
  let sidcliente: string = getSessionStore(eSessionStore.id_cliente);

  if (isNullUndefinedVacio(sidcliente)) {
    sidcliente = "0";
  }
  return parseInt(sidcliente);
}

// Comprueba si hay seleccionado un cliente o es 0 que significa que ha
// accedido un superusuario pero todavía no ha seleccinado ningún
export function oClienteActivo(): Cliente.cCliente {
  const sCliente: string = getSessionStore(eSessionStore.ocliente);
  let oCliente: Cliente.cCliente = null;

  if (!isNullUndefinedVacio(sCliente)) {
    oCliente = JSON.parse(sCliente);
  }
  return oCliente;
}

// Obtenemos nombre del cliente de la variable de sesión
export function getNombreCliente(): string {
  let sCliente = "";
  sCliente = localStorage.getItem("NombreCliente");
  if (isNullUndefinedVacio(sCliente)) {
    sCliente = "";
  }
  return sCliente;
}

// Obtenemos la información del cliente de la variable de sesión
export function getInfoCliente(): Cliente.cCliente {
  let sCliente: string;
  let oCliente: Cliente.cCliente = null;

  sCliente = getSessionStore(eSessionStore.ocliente);
  if (!isNullUndefinedVacio(sCliente)) {
    oCliente = JSON.parse(sCliente);
  }
  return oCliente;
}

export function getAtmConnectConnectionParam(): cAtmConnectConnection {
  const param_string: string = getLocalStore(eLocalStore.AtmConnectConnection);
  if (!param_string) {
    return null;
  }
  const obj = param_string.split(";").reduce((acc, pair) => {
    const [key, value] = pair.split("=");
    if (key) {
      acc[key] = value;
    }
    return acc;
  }, {} as cAtmConnectConnection);
  return obj;
}

// ----------------- VALIDACIONES ---------------------

export interface IValidaIdentificador {
  tipo: string;
  valido: boolean;
  aviso: string;
}

const DNI_REGEX = /^(\d{8})([A-Z])$/;
const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;
const NUM_REGEX = /^\d+$/;

export function ValidaNIFCIFNIE(
  sTipoCodigo: string,
  sCodigo: string,
): IValidaIdentificador {
  const oValida: IValidaIdentificador = { tipo: "", valido: false, aviso: "" };

  // Lo pasamos a mayúsculas y le quitamos los espacios en blanco

  sCodigo = sCodigo.toUpperCase().replace(/\s/, "");
  sTipoCodigo = sTipoCodigo.toUpperCase();

  if (sCodigo.match(DNI_REGEX)) {
    oValida.tipo = "NIF";
  }
  if (sCodigo.match(CIF_REGEX)) {
    oValida.tipo = "CIF";
  }
  if (sCodigo.match(NIE_REGEX)) {
    oValida.tipo = "NIE";
  }

  // Validamos que el tipo recibido sea igual que el obtenido por la función

  if (oValida.tipo !== sTipoCodigo) {
    oValida.aviso =
      "El código es de tipo " + oValida.tipo + " no " + sTipoCodigo + ".";
  } else {
    switch (oValida.tipo) {
      case "NIF":
        oValida.valido = validaDNI(sCodigo);
        break;
      case "NIE":
        oValida.valido = validaNIE(sCodigo);
        break;
      case "CIF":
        oValida.valido = validaCIF(sCodigo);
        break;
    }
    if (!oValida.valido) {
      oValida.aviso = "Código " + oValida.tipo + " no válido.";
    }
  }
  return oValida;
}

function validaDNI(dni: string): boolean {
  const dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
  const letter = dni_letters.charAt(parseInt(dni, 10) % 23);

  return letter == dni.charAt(8);
}

function validaNIE(nie: string): boolean {
  // Change the initial letter for the corresponding number and validate as DNI
  let nie_prefix: any = nie.charAt(0);

  switch (nie_prefix) {
    case "X":
      nie_prefix = 0;
      break;
    case "Y":
      nie_prefix = 1;
      break;
    case "Z":
      nie_prefix = 2;
      break;
  }
  return validaDNI(nie_prefix + nie.substr(1));
}

function validaCIF(cif: string): boolean {
  let cif_ok = false;
  let sumaPares = 0;
  let sumaImpares = 0;
  let sumaParcial = 0;
  let total: number;
  let unidades: number;
  let digitoControl: number;

  const letras = "JABCDEFGHI";
  const ultimoCaracter: string = cif.substr(cif.trim.length - 1, 1);

  let subcad: string = cif.substr(1, cif.length - 2);
  subcad = subcad.padStart(7, "0");

  // comprobamos que la cadena subcad sean todo dígitos
  if (subcad.match(NUM_REGEX)) {
    for (let i = 1; i <= subcad.length; i++) {
      if (i % 2 === 0) {
        sumaPares = sumaPares + parseInt(subcad.substr(i - 1, 1));
      } else {
        sumaParcial = 2 * parseInt(subcad.substr(i - 1, 1));
        if (sumaParcial > 9) {
          sumaParcial = 1 + (sumaParcial % 10);
        } else {
          sumaParcial = sumaParcial % 10;
        }
        sumaImpares = sumaImpares + sumaParcial;
      }
    }
    total = sumaPares + sumaImpares;
    unidades = total % 10;
    digitoControl = (10 - unidades) % 10;

    if (ultimoCaracter.match(NUM_REGEX)) {
      cif_ok = digitoControl === parseInt(ultimoCaracter);
    } else {
      cif_ok = letras.substr(digitoControl % 10, 1) === ultimoCaracter;
    }
  } else {
    cif_ok = false;
  }

  return cif_ok;
}
